export enum PaymentMode {
  Prepaid = 0,
  Postpaid
}